import React, { useContext } from 'react';
import { Link } from "react-router-dom";
import { CartControllerContext } from '../../contexts/CartControllerContext';
import { CookieContext } from '../../contexts/CookieContext';
import {CartIcon} from '../icons';
import styles from './header.module.scss';
import {passList, subscriptionList} from '../../services/scheduleList'

const Header = () => {

    const {cartItemCount} = useContext(CartControllerContext);
    const {allow3rdparty, disallow3rdparty} = useContext(CookieContext);
    const [registered, setRegistered] = React.useState(false);
    const disabled = React.useState(true);


    React.useEffect(() =>{
        var receiveMessage = function (evt) {
            if (evt.data === 'MM:3PCunsupported') {
              //alert('not supported');
              disallow3rdparty();
            } else if (evt.data === 'MM:3PCsupported') {
              //alert('supported');
              allow3rdparty();
            }
          };
          window.addEventListener("message", receiveMessage, false);
          setRegistered(true);
    })

    return ( 
        <header className={styles.header}>
            {
                <div>
                    <Link className="link" to='/'>Schedule</Link>
                    {
                        passList.length > 0 &&
                        <Link className="link" to='/passes'>Passes</Link>
                    }
                    {
                        subscriptionList.length > 0 &&
                        <Link className="link" to='/subscriptions'>Subscriptions</Link>
                    }                    
                    <Link className="link" to='/cart'> <CartIcon/> Cart ({cartItemCount})</Link>
                </div>
            }
            {
                
                registered && disabled === false && window.location.hostname.endsWith('reservie.net') === false &&
                <iframe src="https://d2p08o3nl0hxfj.cloudfront.net/utils/check.html" style={{"height":"1px", "width":"1px", "visibility":"hidden"}} ></iframe>
                
                
            }

        </header>
     );
}
 
export default Header;